'use client';

import { useSearchParams } from 'next/navigation';

import { REG_MODAL_FLOW_PARAMS } from '../helpers/common';

export function useIsRegModalFlow(): boolean {
  const searchParams = useSearchParams();

  return REG_MODAL_FLOW_PARAMS.some(
    (param) => searchParams.get(param) === 'true'
  );
}
